var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "page-layout" }, [
      _c("div", { staticClass: "rectangle-div-box" }, [
        _c("div", { staticClass: "centered-div" }, [
          _c("img", { attrs: { src: "/img/dashboard/layers-icon.svg" } }),
          _c("div", { staticClass: "centered-text" }, [
            _vm._v(
              "\n        Waiting for the Team to sign the Service Level Agreement...\n      "
            ),
          ]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }